import api from './api';

export interface Permissao {
  id: string;
  codigo: string;
  nome: string;
}

export const getAllUsers = () => api.get<Permissao[]>('permissoes');
export const createUser = (permissao: Permissao) => api.post<Permissao>('permissoes', permissao);
export const Get = (id: string) => api.get(`permissoes/${id}`);


export const PermissaoPost = (form: Permissao) => api.post(`permissoes`, form);
